import { Language } from './translations';

export const MechanicHourValue = [
    { value: 100, label: '100%', weight: 100 },
    { value: 90, label: '90%', weight: 90 },
    { value: 80, label: '80%', weight: 80 },
    { value: 75, label: '75%', weight: 75 },
    { value: 50, label: '50%', weight: 50 },
    { value: 25, label: '25%', weight: 25 },
    { value: 10, label: '10%', weight: 10 },
];

export const PrintLayouts = [
    {
        value: 0,
        label: { nl: 'Uren overzicht', en: 'Hours Overview' },
    },
];

export const getPrintLayoutLabel = (value: number, lang: Language): string => {
    const layout = PrintLayouts.find((l) => l.value === value);
    return layout ? layout.label[lang] : '';
};

export const MechanicTypes = [
    { value: 0, label: { nl: 'Monteur', en: 'Mechanic' }, weight: 100 },
    { value: 1, label: { nl: 'Hulpmonteur', en: 'Helper Mechanic' }, weight: 75 },
    { value: 2, label: { nl: 'Hulp', en: 'Helper' }, weight: 25 },
    { value: 3, label: { nl: 'Kantoor', en: 'Office' }, weight: 100 },
    { value: 4, label: { nl: 'Onderaanneming', en: 'Subcontracting' }, weight: 100 },
];

export const getMechanicTypeLabel = (value: number, lang: Language): string => {
    const type = MechanicTypes.find((t) => t.value === value);
    return type ? type.label[lang] : '';
};

export const ProjectTypes = [
    { value: 0, label: { nl: 'Badkamer', en: 'Bathroom' } },
    { value: 1, label: { nl: 'Keuken', en: 'Kitchen' } },
    { value: 2, label: { nl: 'Toilet', en: 'Toilet' } },
];

export const getProjectTypeLabel = (value: number, lang: Language): string => {
    const type = ProjectTypes.find((t) => t.value === value);
    return type ? type.label[lang] : '';
};